import { render } from "./TradesPivotrade.vue?vue&type=template&id=7cc12e66"
import script from "./TradesPivotrade.vue?vue&type=script&lang=js"
export * from "./TradesPivotrade.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__